import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { genreSelector, heroSelector } from 'src/redux/app/selectors';
import Genre from 'components/FeatureBlock/FeatureBlock';
import Hero from 'components/Hero/Hero';
import Breadcrumb from 'components/_utility/Breadcrumb/Breadcrumb';
import NoResults from 'components/_utility/NoResults/NewResults';
import Loader from 'components/_utility/Loader/Loader';
import request from 'helpers/request';
import { setFeatureCards } from 'src/redux/bikes/actions';
import { setError } from 'src/redux/app/actions';
import { getFeatureCardCount } from 'src/redux/bikes/selectors';
import Modal from 'components/_utility/Modal/Modal';
import DisclaimerModal from 'components/DisclaimerModal/DisclaimerModal';
import { openModalSelector } from 'src/redux/configurator/selectors';
import { setSelectedDisclaimer, closeModal } from 'src/redux/configurator/actions';
import { Wrap, NoResultsWrap } from './Genres.styled';

const Genres = () => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(true);
  const genres = useSelector(genreSelector);
  const hero = useSelector(heroSelector);
  const count = useSelector(getFeatureCardCount('genre'));
  const openModals = useSelector(openModalSelector);

  useEffect(() => {
    const fetchFamiliesOrBikes = async () => {
      try {
        const genrePromises = genres.map(
          async genre =>
            new Promise(async resolve => {
              const res = await request(`/api/configurator/bikes/families?genre=${genre.id}`);

              resolve({ id: genre.id, cards: res.data.bikes });
            })
        );
        const genresWithCards = await Promise.all(genrePromises);

        dispatch(setFeatureCards({ features: genresWithCards, type: 'genre' }));
        setLoading(false);
      } catch (ex) {
        dispatch(setError(ex));
      }
    };

    fetchFamiliesOrBikes();
  }, []);

  if (loading) {
    return <Loader />;
  }

  return (
    <>
      <Hero
        buttons={[{ id: 'viewall', label: 'viewAllButton', to: '/bikes' }]}
        title={hero.title}
        image={hero.image}
        viewHidden
        fluid
        hasFilters
        isGenrePage
      />
      <Wrap>
        {count ? (
          genres.map(genre => (
            <Genre
              key={genre.id}
              id={genre.id}
              title={genre.title}
              description={genre.description}
              ctaColour={genre.ctacolour}
            />
          ))
        ) : (
          <NoResultsWrap>
            <NoResults />
          </NoResultsWrap>
        )}
      </Wrap>
      {openModals.disclaimer ? (
        <Modal onClose={() => [dispatch(closeModal('disclaimer')), dispatch(setSelectedDisclaimer(null))]}>
          <DisclaimerModal />
        </Modal>
      ) : null}
      <Breadcrumb />
    </>
  );
};

export default Genres;
